import {observable} from 'mobx';

export class LivePointerRoomStorage {
    @observable connected: boolean = false;
}
